__turbopack_context__.v({
  "coronaContent": "drI4OW_coronaContent",
});
